import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { StorageProvider } from '../../../services/storage.provider';

@Component({
  selector: 'app-cookie-info',
  templateUrl: 'cookie-info.html',
  styleUrls: ['cookie-info.scss']
})
export class CookieInfoComponent implements OnInit {
  public show = true;

  constructor(private storage: StorageProvider, private router: Router) {}

  ngOnInit() {
    this.checkAccepted();
  }

  cookieAccepted() {
    this.show = false;
    this.storage.setStorage('cookie', 'accepted');
  }

  checkAccepted() {
    if (this.storage.getStorage('cookie')) {
      if (this.storage.getStorage('cookie') !== 'accepted') {
        this.show = true;
      } else {
        this.show = false;
      }
    }
  }

  goToLegal() {
    this.router.navigate(['page', 'cookies']);
  }
}
